var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-start mb-2"},[_c('v-icon',{staticClass:"mr-3 mt-1",attrs:{"color":"grey"}},[_vm._v(_vm._s(_vm.icon))]),_c('div',[_c('div',{staticClass:"text-caption text--secondary"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"text-subtitle-1 font-weight-medium"},[_vm._v(_vm._s(_vm.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }